import _ from 'lodash';
export default {
  methods: {
    inputOnBackgroundCheckGameAction() {
      let entanglements = {};
      let status = _.reduce(
        this.inputData,
        (result, value, key) => {
          let temVal = null;
          /**
           * if entanglements is set buy coupled property
           * @method if
           * @param  {Object} value input object
           * @return {object}       entanglements oject with keys
           */
          if (value.coupled && _.isNil(entanglements[value.coupled])) {
            entanglements = _.extend({}, entanglements, {
              [value.coupled]: [],
            });
          }
          let index;
          let correctArray = _.isArray(value.correct) ? value.correct : [value.correct];
          if (value.coupled) {
            /**
             * set correct array without element already used in this entanglement
             * @type {array}
             */
            correctArray = _.difference(correctArray, entanglements[value.coupled]);
          }
          index = _.findIndex(correctArray, (o) => {
            if (value.caseSensitive) {
              return o === _.trim(value.val);
            } else {
              return o === _.trim(value.val.toLowerCase());
            }
          });
          if (index != -1) {
            temVal = result && true;
            if (value.coupled) {
              /**
               * set value.val as 'use' in entanglements array
               * @type {[type]}
               */
              entanglements[value.coupled].push(value.val);
            }
            if (value.caseSensitive) {
              value.val = _.trim(value.val);
            } else {
              value.val = _.trim(value.val.toLowerCase());
            }
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.val = '';
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      // console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.inputData, (item, key) => {
          // console.log('item', item);
        });
      }
      return status;
    },
  },
};
